import React, { useState, useRef, useEffect } from "react";

const hudButtonStyle = (pressed) => ({
  padding: "6px 10px",
  minWidth: 72,
  fontSize: 12,
  fontFamily: '"MS Sans Serif", Tahoma, Arial, sans-serif',
  color: "#111827",
  background: pressed ? "rgba(240,240,240,0.98)" : "rgba(255,255,255,0.92)",
  border: "1px solid #c7c7c7",
  borderRadius: 6,
  boxShadow: "0 2px 6px rgba(0,0,0,0.08)",
  cursor: "pointer",
  lineHeight: "1.2",
});

export default function GoToCoords({ onGo }) {
  const [x, setX] = useState(0);
  const [y, setY] = useState(0);
  const [open, setOpen] = useState(false);
  const [pressed, setPressed] = useState(false);
  const wrapperRef = useRef(null);

  const submit = (e) => {
    e && e.preventDefault && e.preventDefault();
    const nx = Number(x);
    const ny = Number(y);
    if (Number.isFinite(nx) && Number.isFinite(ny) && onGo) onGo(nx, ny);
    setOpen(false);
  };

  // close when clicking outside
  useEffect(() => {
    if (!open) return;
    function onDoc(e) {
      if (!wrapperRef.current) return;
      if (!wrapperRef.current.contains(e.target)) setOpen(false);
    }
    document.addEventListener("pointerdown", onDoc);
    return () => document.removeEventListener("pointerdown", onDoc);
  }, [open]);

  return (
    <div ref={wrapperRef} style={{ pointerEvents: "auto" }}>
      {!open ? (
        <button
          aria-label="open-goto-coords"
          onClick={() => setOpen(true)}
          onMouseDown={() => setPressed(true)}
          onMouseUp={() => setPressed(false)}
          onMouseLeave={() => setPressed(false)}
          onPointerDown={() => setPressed(true)}
          onPointerUp={() => setPressed(false)}
          style={hudButtonStyle(pressed)}
          title="Go to coordinates"
        >
          goto
        </button>
      ) : (
        <form
          onSubmit={submit}
          style={{
            display: "flex",
            gap: 6,
            alignItems: "center",
            pointerEvents: "auto",
          }}
        >
          <input
            aria-label="goto-x"
            type="number"
            value={x}
            onChange={(e) => setX(e.target.value)}
            placeholder="x"
            style={{ width: 80, padding: "6px 8px", fontSize: 12 }}
            autoFocus
          />
          <input
            aria-label="goto-y"
            type="number"
            value={y}
            onChange={(e) => setY(e.target.value)}
            placeholder="y"
            style={{ width: 80, padding: "6px 8px", fontSize: 12 }}
          />
          <button
            type="submit"
            style={hudButtonStyle(false)}
            onMouseDown={(e) =>
              e.currentTarget && e.currentTarget.blur && e.currentTarget.blur()
            }
          >
            Go
          </button>
          <button
            type="button"
            onClick={() => setOpen(false)}
            style={hudButtonStyle(false)}
          >
            Cancel
          </button>
        </form>
      )}
    </div>
  );
}
